import App from "./App.svelte";
function replaceText(text, unit, usePoint) {
    var _a;
    const exp = RegExp(/\b(20\d{2})\D?([01]?\d)\D?([0-3]?\d)\D?([0-2]?\d)\D?([0-5]?\d)\D?([0-5]?\d)([\.,]\d+)?秒?(\s?Z|\s?[\-\+]\d{2}:?\d?\d?)?/, 'g');
    let arr;
    let table = [];
    while ((arr = exp.exec(text)) != null) {
        const year = Number(arr[1]);
        let month = Number(arr[2]);
        if (month > 12) {
            continue;
        }
        else if (month < 10) {
            month = '0' + month;
        }
        let day = Number(arr[3]);
        if (day > 31) {
            continue;
        }
        else if (day < 10) {
            day = '0' + day;
        }
        let hour = Number(arr[4]);
        if (hour > 24) {
            continue;
        }
        else if (hour < 10) {
            hour = '0' + hour;
        }
        let min = Number(arr[5]);
        if (min > 60) {
            continue;
        }
        else if (min < 10) {
            min = '0' + min;
        }
        let sec = Number(arr[6]);
        if (sec > 60) {
            continue;
        }
        else if (sec < 10) {
            sec = '0' + sec;
        }
        let secAfterPoint = arr[7] ? arr[7].substr(1) : "";
        switch (unit) {
            case 0.001:
                secAfterPoint = "";
                break;
            case 1:
                if (secAfterPoint.length < 3) {
                    const loop = 3 - secAfterPoint.length;
                    for (let i = 0; i < loop; ++i) {
                        secAfterPoint = secAfterPoint + '0';
                    }
                }
                else if (secAfterPoint.length > 3) {
                    secAfterPoint = secAfterPoint.substr(0, 3);
                }
                break;
            case 1000:
                if (secAfterPoint.length < 6) {
                    const loop = 6 - secAfterPoint.length;
                    for (let i = 0; i < loop; ++i) {
                        secAfterPoint = secAfterPoint + '0';
                    }
                }
                else if (secAfterPoint.length > 6) {
                    secAfterPoint = secAfterPoint.substr(0, 6);
                }
                break;
            case 1000000:
                if (secAfterPoint.length < 9) {
                    const loop = 9 - secAfterPoint.length;
                    for (let i = 0; i < loop; ++i) {
                        secAfterPoint = secAfterPoint + '0';
                    }
                }
                else if (secAfterPoint.length > 9) {
                    secAfterPoint = secAfterPoint.substr(0, 9);
                }
                break;
        }
        if (usePoint && unit != 0.001) {
            secAfterPoint = '.' + secAfterPoint;
        }
        let timezone = (_a = arr[8]) !== null && _a !== void 0 ? _a : "";
        timezone = timezone.trim();
        let tmp = timezone.match(/([\+\-]\d{2}):?(\d?\d?)/);
        if (tmp != null) {
            if (tmp[2].length == 0) {
                timezone = tmp[1] + ':' + '00';
            }
            else if (tmp[2].length == 1) {
                timezone = tmp[1] + ':' + '0' + tmp[2];
            }
        }
        const date = new Date(year + '-' + month + '-' + day + 'T' + hour + ':' + min + ':' + sec + timezone);
        if (isNaN(date.valueOf())) {
            continue;
        }
        const number = parseInt((date.valueOf() * 0.001).toString()).toString() + secAfterPoint;
        table.push([arr[0], number]);
    }
    table.forEach((v, i, a) => {
        text = text.replace(v[0], v[1]);
    });
    return text;
}
const app = new App({
    target: document.body,
    props: {
        replaceText: replaceText,
        handleClickCopy: () => {
            const out = document.getElementById("output-text");
            out.select();
            document.execCommand("copy");
            out.selectionStart = out.selectionEnd;
        }
    }
});
export default app;
